var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"content"}},[_c('ha-committee-under-review',{attrs:{"urlParams":_vm.urlParams}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }